import Banner from 'componentes/Banner'
import ListaFormacoes from 'componentes/ListaFormacoes'
import ListaProjetos from 'componentes/ListaProjetos'
import SobreMim from 'componentes/SobreMim'
import React from 'react'
import styles from './PaginaInicial.module.css'
import Apresentacao from 'componentes/Apresentacao'

export default function ModoSerio() {
    return (
        <section>\
            <Apresentacao />
            <SobreMim />
            <Banner titulo='Formações' imagem='serio' />
            <div className={styles.formacoes}>
                <ListaFormacoes />
            </div>
            <Banner imagem='serio' titulo='Projetos' />
            <div className={styles.listaProjetos}>
                <ListaProjetos />
            </div>
        </section>
    )
}

